<template>
  <div class="admin-layout">
    <el-container>
      <el-container>
        <!-- 侧边栏 -->
        <el-aside width="240px" class="sidebar">
          <!-- 顶部logo区域 -->
          <div class="sidebar-header">
            <div class="logo-container">
              <div class="logo-icon">
                <i class="el-icon-s-home"></i>
              </div>
              <div class="logo-text">
                <div class="brand-name">祯丹堂</div>
                <div class="brand-subtitle">管理中心</div>
              </div>
            </div>
          </div>
          
          <!-- 菜单区域 -->
          <div class="menu-container">
            <el-menu
              :default-active="$route.path"
              class="sidebar-menu"
              router
              unique-opened
            >
              <el-menu-item index="/" class="menu-item-overview">
                <i class="el-icon-monitor"></i>
                <span slot="title">概览页面</span>
              </el-menu-item>
              
              <el-menu-item index="/admin" class="menu-item">
                <i class="el-icon-setting"></i>
                <span slot="title">管理员管理</span>
              </el-menu-item>
              
              <el-menu-item index="/admin/users" class="menu-item">
                <i class="el-icon-user-solid"></i>
                <span slot="title">用户管理</span>
              </el-menu-item>
              
              <el-menu-item index="/admin/membership-levels" class="menu-item">
                <i class="el-icon-medal"></i>
                <span slot="title">会员等级管理</span>
              </el-menu-item>
              
              
              <el-submenu index="store" class="menu-submenu">
                <template slot="title">
                  <i class="el-icon-s-shop"></i>
                  <span>门店管理</span>
                </template>
                <el-menu-item index="/admin/stores" class="submenu-item">
                  <span slot="title">门店列表</span>
                </el-menu-item>
                <el-menu-item index="/admin/agents" class="submenu-item">
                  <span slot="title">代理列表</span>
                </el-menu-item>
                <el-menu-item index="/admin/store-applications" class="submenu-item">
                  <span slot="title">申请审核</span>
                </el-menu-item>
              </el-submenu>
              
              <el-submenu index="product" class="menu-submenu">
                <template slot="title">
                  <i class="el-icon-goods"></i>
                  <span>商品管理</span>
                </template>
                <el-menu-item index="/admin/products" class="submenu-item">
                  <span slot="title">商品列表</span>
                </el-menu-item>
                <el-menu-item index="/admin/products/create" class="submenu-item">
                  <span slot="title">新增商品</span>
                </el-menu-item>
              </el-submenu>
              
              <el-submenu index="coupon" class="menu-submenu">
                <template slot="title">
                  <i class="el-icon-present"></i>
                  <span>优惠券管理</span>
                </template>
                <el-menu-item index="/admin/coupons/templates" class="submenu-item">
                  <span slot="title">模板管理</span>
                </el-menu-item>
                <el-menu-item index="/admin/coupons/issue" class="submenu-item">
                  <span slot="title">优惠券发放</span>
                </el-menu-item>
              </el-submenu>
              
              <el-submenu index="banner" class="menu-submenu">
                <template slot="title">
                  <i class="el-icon-picture-outline"></i>
                  <span>轮播图管理</span>
                </template>
                <el-menu-item index="/admin/banners" class="submenu-item">
                  <span slot="title">轮播图列表</span>
                </el-menu-item>
                <el-menu-item index="/admin/banners/create" class="submenu-item">
                  <span slot="title">新增轮播图</span>
                </el-menu-item>
              </el-submenu>
              
              <el-submenu index="announcement" class="menu-submenu">
                <template slot="title">
                  <i class="el-icon-chat-line-square"></i>
                  <span>公告管理</span>
                </template>
                <el-menu-item index="/admin/announcements" class="submenu-item">
                  <span slot="title">公告列表</span>
                </el-menu-item>
                <el-menu-item index="/admin/announcements/create" class="submenu-item">
                  <span slot="title">新增公告</span>
                </el-menu-item>
              </el-submenu>
              
            </el-menu>
          </div>
        </el-aside>
        
        <!-- 主内容区 -->
        <el-main class="main-content">
          <!-- 页面内容 -->
          <div class="page-content">
            <router-view/>
          </div>
          
          <!-- 用户下拉菜单 - 固定在右上角 -->
          <div class="user-dropdown">
            <el-dropdown @command="handleCommand" class="admin-dropdown">
              <span class="el-dropdown-link">
                {{ adminInfo ? adminInfo.real_name : '管理员' }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { logout, getProfile } from '@/api/admin'

export default {
  name: 'AdminLayout',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['adminInfo'])
  },
  mounted() {
    this.loadAdminInfo()
  },
  methods: {
    ...mapActions(['setAdminInfo', 'logout']),
    
    async loadAdminInfo() {
      try {
        const res = await getProfile()
        this.setAdminInfo(res.data)
      } catch (error) {
        console.error('获取管理员信息失败:', error)
      }
    },
    
    handleCommand(command) {
      if (command === 'logout') {
          this.handleLogout()
      }
    },
    
    async handleLogout() {
      try {
        await logout()
      } catch (error) {
        console.error('登出失败:', error)
      } finally {
        this.logout()
        this.$router.push('/login')
        this.$message.success('已退出登录')
      }
    }
  }
}
</script>

<style scoped>
.admin-layout {
  height: 100vh;
  overflow: hidden;
  background: #f8fafb;
}

/* 侧边栏样式 */
.sidebar {
  background: linear-gradient(180deg, #667eea 0%, #764ba2 30%, #667eea 70%, #5a67d8 100%);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 240px;
  z-index: 1000;
  overflow-y: auto;
  box-shadow: 2px 0 12px rgba(102, 126, 234, 0.15);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

/* 侧边栏头部logo区域 */
.sidebar-header {
  padding: 35px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
}

.sidebar-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.6) 50%, transparent 100%);
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 14px;
}

.logo-icon {
  width: 52px;
  height: 52px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.8);
}

.logo-icon i {
  font-size: 24px;
  color: #667eea;
}

.logo-text {
  display: flex;
  flex-direction: column;
}

.brand-name {
  font-size: 22px;
  font-weight: 600;
  color: white;
  line-height: 1.2;
  margin-bottom: 3px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.brand-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  opacity: 0.9;
  line-height: 1.3;
}

/* 菜单容器 */
.menu-container {
  padding: 16px 0;
}

/* 菜单基础样式重写 */
.sidebar-menu {
  border: none;
  background: transparent;
  width: 100%;
}

/* 一级菜单项样式 */
.sidebar-menu :deep(.el-menu-item) {
  height: 48px;
  line-height: 48px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-weight: 500;
  margin: 2px 12px;
  border-radius: 8px;
  padding-left: 20px !important;
  transition: all 0.3s ease;
}

.sidebar-menu :deep(.el-menu-item:hover) {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.sidebar-menu :deep(.el-menu-item.is-active) {
  background: rgba(255, 255, 255, 0.25);
  color: white;
  box-shadow: 0 2px 8px rgba(255, 255, 255, 0.2);
  font-weight: 600;
}

/* 子菜单样式 */
.sidebar-menu :deep(.el-submenu__title) {
  height: 48px;
  line-height: 48px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-weight: 500;
  margin: 2px 12px;
  border-radius: 8px;
  padding-left: 20px !important;
  transition: all 0.3s ease;
}

.sidebar-menu :deep(.el-submenu__title:hover) {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.sidebar-menu :deep(.el-submenu.is-active .el-submenu__title) {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

/* 子菜单下拉箭头 */
.sidebar-menu :deep(.el-submenu__icon-arrow) {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  margin-top: -1px;
}

/* 子菜单内容区域 */
.sidebar-menu :deep(.el-menu--inline) {
  background: rgba(255, 255, 255, 0.1);
  margin: 4px 12px 8px 12px;
  border-radius: 10px;
  padding: 6px 0;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* 子菜单项样式 */
.sidebar-menu :deep(.el-menu--inline .el-menu-item) {
  height: 40px;
  line-height: 40px;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  margin: 1px 8px;
  padding-left: 32px !important;
  border-radius: 6px;
}

.sidebar-menu :deep(.el-menu--inline .el-menu-item:hover) {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.sidebar-menu :deep(.el-menu--inline .el-menu-item.is-active) {
  background: rgba(255, 255, 255, 0.3);
  color: white;
  box-shadow: 0 2px 6px rgba(255, 255, 255, 0.2);
  font-weight: 600;
}

/* 菜单图标样式 */
.sidebar-menu :deep(.el-menu-item i),
.sidebar-menu :deep(.el-submenu__title i) {
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  margin-right: 12px;
  width: 16px;
  text-align: center;
}

.sidebar-menu :deep(.el-menu-item.is-active i),
.sidebar-menu :deep(.el-submenu.is-active .el-submenu__title i) {
  color: white;
}

/* 主内容区域 */
.main-content {
  background-color: #f8fafb;
  padding: 0;
  margin-left: 240px;
  height: 100vh;
  overflow-y: auto;
  position: relative;
}

/* 页面内容区域 */
.page-content {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background: #f8fafb;
}

/* 用户下拉菜单 */
.user-dropdown {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1001;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  border-radius: 8px;
  padding: 8px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.admin-dropdown .el-dropdown-link {
  cursor: pointer;
  color: #667eea;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.admin-dropdown .el-dropdown-link:hover {
  color: #764ba2;
}

/* 滚动条样式 */
.sidebar::-webkit-scrollbar {
  width: 4px;
}

.sidebar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

.sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar {
    width: 200px;
  }
  
  .main-content {
    margin-left: 200px;
  }
  
  .user-dropdown {
    top: 16px;
    right: 16px;
    padding: 6px 12px;
  }
  
  .sidebar-header {
    padding: 21px 16px;
  }
  
  .brand-name {
    font-size: 16px;
  }
}

/* 特殊菜单项样式 */
.menu-item-overview {
  /* 概览页面特殊样式 */
  position: relative;
}

/* 当前激活的菜单项强制样式 */
.sidebar-menu :deep(.el-menu-item.active-item),
.sidebar-menu :deep(.el-menu--inline .el-menu-item.active-item) {
  background: rgba(255, 255, 255, 0.3) !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(255, 255, 255, 0.2) !important;
  font-weight: 600 !important;
}

/* 菜单项边距调整 */
.sidebar-menu :deep(.el-submenu) {
  margin-bottom: 4px;
}

/* 子菜单展开后的样式调整 */
.sidebar-menu :deep(.el-submenu.is-opened .el-submenu__title) {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

/* 确保图标在活跃状态下显示为白色 */
.sidebar-menu :deep(.el-menu-item.active-item i) {
  color: white !important;
}
</style> 